import React from 'react'
import InviteInstructors from '../../../components/InviteInstructors'


export default function Invite() {

    return <InviteInstructors redirectUrl="/manage" />
}